import { Box, HStack, VStack } from '@chakra-ui/react';
import { FrameworkBox } from 'Molecules/FrameworkBox';
import { Typography } from 'Tokens/Typography';
import { useFeatureFlags } from 'containers/Navigation';
import React from 'react';
import { useCurrentCompany } from 'utils/hooks';
import { useTranslation } from 'utils/translation';
import { EmptyState } from 'Atoms';

export const HomeReportingFrameworks = () => {
  const { t } = useTranslation('home');
  const { company } = useCurrentCompany();
  const {
    assessments: hasTaxonomyAccess,
    pai: hasPaiAccess,
    hasSustainabilityAccess: hasSustainabilityAccess
  } = useFeatureFlags({ company });

  return (
    <VStack alignItems="stretch" justifyContent="flex-start" spacing="0px">
      <HStack height="100%" mb="8px">
        <Typography variant="bodyStrong" color="text.default">
          {t('home:cards.frameworks')}
        </Typography>
      </HStack>
      <HStack spacing="10px" alignItems="stretch" pb="48px">
        {hasSustainabilityAccess && (
          <Box flex={1} display={"flex"}>
            <FrameworkBox
              title={t('home:cards.sustainabilityReporting.title')}
              description={t('home:cards.sustainabilityReporting.description')}
              link="sustainability-reporting"
            />
          </Box>
        )}
        {hasPaiAccess && (
          <Box flex={1} display={"flex"}>
            <FrameworkBox
              title={t('home:cards.pai.title')}
              description={t('home:cards.pai.description')}
              link="pai"
            />
          </Box>
        )}
        <Box flex={1} display={"flex"}>
          {hasTaxonomyAccess ? (
            <FrameworkBox
              title={t('home:cards.eutaxonomy.title')}
              description={t('home:cards.eutaxonomy.description')}
              link="assessments"
            />
          ) : (
            <EmptyState
              title={
                <Typography variant="h3">
                  {t('home:cards.eutaxonomy.not-eligible.title')}
                </Typography>}
              description={
                <Typography {...hasSustainabilityAccess || hasPaiAccess ? {} : { minW: "420px", minH: "80px" }} variant="body">
                  {t('home:cards.eutaxonomy.not-eligible.description')}
                </Typography>
              }
              {...hasSustainabilityAccess || hasPaiAccess ? {
                width: 'full',
                padding: "20px",
                paddingBottom: "16px",
                VStackMinH: 'none',
              } : {
                component: true,
              }}
            />
          )}
        </Box>
      </HStack>
    </VStack>
  );
};
